import Link from '@tiptap/extension-link';
import { mergeAttributes } from '@tiptap/core';
import { linkTypeOf } from './link-click-extension';

/**
 * Link mark extended to tag every `<a>` with `data-link-type`
 * (document / anchor / external), derived from its href. This puts the
 * attribute on the anchor itself — where globals.css `a[data-link-type='…']`
 * expects it for the link-kind icon — rather than on a wrapping decoration
 * span (which the selector wouldn't match).
 *
 * Replaces StarterKit's bundled Link (`StarterKit.configure({ link: false })`),
 * configured with `protocols: ['nula']` so nula://document/<id> hrefs survive.
 * Restores the legacy Lexical `data-link-type` styling.
 */
export const DocumentLink = Link.extend({
  renderHTML({ HTMLAttributes }) {
    const href = (HTMLAttributes.href as string | undefined) ?? '';
    return [
      'a',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        'data-link-type': linkTypeOf(href),
      }),
      0,
    ];
  },
});
